import cn from "@utils/cn";

const CLASS_NAMES = cn(`
  container
  flex
  flex-col
  max-w-(--breakpoint-2xl)
  gap-4
  px-4
  pt-0
  pb-mobile-navbar-height
  mx-auto
  md:pt-navbar-height
  md:pb-4
`);

export default function Page(props) {
  const {
    className,
  } = props;

  return (
    <div className={cn(CLASS_NAMES, className)}>
      {props.children}
    </div>
  );
}
